<template>
  <v-app>
    <side-bar v-if="sideBarShow" :is-drawer-open.sync="isDrawerOpen"></side-bar>
    <app-bar @appBarNavClick="isDrawerOpen = !isDrawerOpen"></app-bar>
    <v-main>
      <div class="app-content-container pa-4">
        <slot></slot>
      </div>
    </v-main>
    <app-footer v-if="footerShow" :content="footerContent"></app-footer>
    <loading-overlay :loading="loading" />
    <SnackBar />
    <InputBox />
    <MessageBox />
  </v-app>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useAppStore } from "../store/app";

import SideBar from "./components/vertical-nav-menu/SideBar.vue";
import LoadingOverlay from "../components/shared/LoadingOverlay.vue";
import AppFooter from "./components/AppFooter.vue";
import AppBar from "./components/horizontal-nav-menu/AppBar.vue";
import MessageBox from "@/components/shared/MessageBox.vue";
import InputBox from "@/components/shared/InputBox.vue";
import SnackBar from "@/components/shared/SnackBar.vue";

export default {
  name: "ContentLayout",

  components: {
    SnackBar,
    SideBar,
    LoadingOverlay,
    AppFooter,
    AppBar,
    MessageBox,
    InputBox,
  },

  data() {
    return {
      isDrawerOpen: true,
      keyword: null,
    };
  },

  computed: {
    ...mapState(useAppStore, {
      sideBarShow: (store) => store.config.sideBarShow,
      footerShow: (store) => store.config.footerShow,
      footerContent: (store) => store.config.footerContent,
      messageVisible: (store) => store.messageVisible,
      message: (store) => store.message,
      loading: (store) => store.loading,
      messageBox: (store) => store.messageBox,
    }),
  },

  methods: {
    messageHandler(e) {
      if (!e) {
        this.hideMessage();
      }
    },

    ...mapActions(useAppStore, ["hideMessage"]),
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>